// https://stripe.com/docs/currencies#zero-decimal
export const STRIPE_ZERO_DECIMAL_CURRENCIES = ['JPY', 'KRW'];
